import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBellMuted = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 13.0014C10.7443 14.6728 10 16.75 10 19V29H27.5M14.5 10.6486C16.0782 9.60667 17.9687 9 20 9C25.52 9 30 13.48 30 19V25.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0001 33C18.3401 33 17.0001 31.66 17.0001 30V29H23.0001V30C23.0001 31.66 21.6601 33 20.0001 33Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7.70711,
			y1: 8.29289,
			x2: 31.7071,
			y2: 32.2929,
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgBellMuted);
export default ForwardRef;
